import { render, staticRenderFns } from "./add-action.vue?vue&type=template&id=52e1f1d8&scoped=true&"
import script from "./add-action.vue?vue&type=script&lang=js&"
export * from "./add-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e1f1d8",
  null
  
)

export default component.exports